<form
  class="p-3 flex flex-column gap-3"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
>
  <div class="flex flex-column gap-1">
    <label for="email">E-mail</label>
    <input
      id="email"
      type="email"
      pInputText
      formControlName="email"
      autocomplete="email"
    />
  </div>

  <div class="flex flex-column gap-1">
    <label for="password">Hasło</label>
    <input
      id="password"
      type="password"
      pInputText
      formControlName="password"
      autocomplete="current-password"
    />
  </div>

  @if (error()) {
  <small class="p-error red">{{ error() }}</small>
  }

  <div class="flex justify-content-end gap-2 mt-2">
    <button
      pButton
      type="button"
      label="Anuluj"
      (click)="ref.close(false)"
      [disabled]="loading()"
    ></button>
    <button
      pButton
      type="submit"
      label="Zaloguj"
      [loading]="loading()"
      [disabled]="form.invalid || loading()"
    ></button>
  </div>

  <div class="flex justify-content-end">
    <span
      style="
        text-decoration: underline;
        color: rgb(22, 22, 163);
        cursor: pointer;
      "
      (click)="openRegisterDialog()"
      >Nie masz jeszcze konta ? Zarejestruj się!</span
    >
  </div>
</form>
